import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-6 col-lg-3" }
const _hoisted_3 = { class: "col-6 col-lg-3" }
const _hoisted_4 = { class: "col-6 col-lg-3" }
const _hoisted_5 = { class: "col-6 col-lg-3" }
const _hoisted_6 = { class: "col-6 col-lg-2" }
const _hoisted_7 = { class: "col-2 d-flex align-items-center" }
const _hoisted_8 = { class: "form-check form-check-inline" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Привлеченный сотрудник", -1)
const _hoisted_10 = {
  key: 0,
  class: "col-6 col-lg-2"
}
const _hoisted_11 = { class: "col-6 col-lg-2" }
const _hoisted_12 = { class: "col-6 col-lg-2" }
const _hoisted_13 = { class: "col-6 col-lg-2" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = ["value", "onBlur", "onFocus"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите дату принятия ", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-xl",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите ФИО",
              label: "ФИО",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isNameError,
                  placeholder: "ФИО"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите должность",
              label: "Должность",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.post,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.post) = $event)),
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isPostError,
                  placeholder: "Должность"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите ИИН",
              label: "ИИН"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.iin,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.iin) = $event)),
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isIINError,
                  mask: { mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ }}},
                  maxlength: "12",
                  placeholder: "ИИН"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите контакты",
              label: "Контакты"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.contact,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.contact) = $event)),
                  placeholder: "Контакты"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите СКУД",
              label: "СКУД"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.pacsCards,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.pacsCards) = $event)),
                  placeholder: "СКУД"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.isNotOurEmployee) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.state.isNotOurEmployee]
              ]),
              _hoisted_9
            ])
          ]),
          (_ctx.state.isNotOurEmployee)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Выберите юр.лицо",
                  label: "Юр.лицо",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_ui, {
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isSupplierError,
                      "item-key": "name",
                      options: _ctx.suppliers,
                      placeholder: "Юр.лицо",
                      searchable: true,
                      values: [_ctx.state.supplierId],
                      onOnSelected: _ctx.handleSupplierSelect
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите основание",
              label: "Основание",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isOrganizationIdError,
                  "item-key": "name",
                  options: _ctx.organizations,
                  placeholder: "Основание",
                  searchable: true,
                  values: [_ctx.state.organizationId],
                  onOnSelected: _ctx.onOrganizationSelected
                }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите цех (подразделение)",
              label: "Цех (подразделение)",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isDepartmentError,
                  options: _ctx.departments,
                  placeholder: "Цех (подразделение)",
                  searchable: true,
                  values: [_ctx.state.departmentId],
                  onOnSelected: _ctx.onDepartmentSelected
                }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите дату",
              label: "Дата принятия",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.state.hiredAt,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.hiredAt) = $event)),
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date",
                  timezone: 'Asia/Almaty'
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.isHiredAtError && _ctx.state.visibleErrors, 'bg-white': true }]),
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_15),
                      _hoisted_16
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}